import React from 'react';
import Card from '../Card';
import './InsightsPanel.css';

export default function InsightsPanel({ insights, loading }) {
  if (loading) {
    return (
      <Card>
        <h2 className="card-title">💡 Insights</h2>
        <div className="insights-loading">Loading insights...</div>
      </Card>
    );
  }

  if (!insights || insights.length === 0) {
    return (
      <Card>
        <h2 className="card-title">💡 Insights</h2>
        <div className="insights-empty">
          Not enough data to generate insights yet. Start sending messages to see analytics.
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <h2 className="card-title">💡 Insights</h2>
      <div className="insights-list">
        {insights.map((insight, idx) => {
          // Determine insight type based on content
          let insightClass = 'insight-item';
          if (insight.includes('⚠️') || insight.toLowerCase().includes('high failure')) {
            insightClass += ' insight-warning';
          } else if (insight.includes('✓') || insight.toLowerCase().includes('excellent')) {
            insightClass += ' insight-success';
          } else if (insight.toLowerCase().includes('best') || insight.includes('×')) {
            insightClass += ' insight-highlight';
          }

          return (
            <div key={idx} className={insightClass}>
              <span className="insight-bullet">•</span>
              <span className="insight-text">{insight}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
